<template>
    <v-card flat>
        <v-toolbar flat dense color="#26c6da">
            <v-toolbar-title class="subheading">项目立项</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider style="max-height: 1px"/>
        <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

        <v-card-text style="max-width: 990px; margin: 0 auto" class="text-xs-center">
            <v-form v-model="formValid" ref="formRef" lazy-validation>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12 sm12>
                            <v-text-field
                                    label="项目名称"
                                    required
                                    :rules="rules.required"
                                    v-model="item.name"/>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-autocomplete
                                    item-text="name"
                                    item-value="dbid"
                                    :items="typeItems"
                                    :loading="typeLoading"
                                    v-model="item.typeId"
                                    label="项目类别"
                                    required
                                    :rules="rules.required"
                                    hide-details
                                    clearable
                                    :menu-props="{maxHeight:400}"
                                    @change="(it) => {
                    item.client = typeItems.find(v => v.dbid === it).source || item.client;
                    if(!devProjTypeIds.includes(it)) {
                      item.turnover = null;
                    }
                  }"
                            >
                                <template slot="item" slot-scope="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-tile-content v-text="data.item.name"/>
                                    </template>
                                    <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="pl-3" v-html="data.item.name"/>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-text-field
                                    label="委托单位"
                                    required
                                    :rules="rules.required"
                                    v-model="item.client"/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="项目批准号"
                                    required
                                    :rules="rules.required"
                                    v-model="item.number"
                                    hint='没有批准号时，请填"无"。'
                                    persistent-hint
                            />
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="合同金额"
                                    required
                                    :rules="rules.amount"
                                    v-model="item.contractAmounts"
                                    prefix="¥"
                                    suffix="元"
                                    hint="填写数字, 最多保留两位小数。"
                                    persistent-hint
                            />
                        </v-flex>

                        <v-flex xs12 sm2>
                            <v-text-field
                                    label="技术交易额"
                                    required
                                    :rules="rules.turnover"
                                    v-model="item.turnover"
                                    prefix="¥"
                                    suffix="元"
                                    hint="填写数字, 最多保留两位小数。"
                                    persistent-hint
                                    :disabled="!devProjTypeIds.includes(item.typeId)"
                            />
                        </v-flex>

                      <v-flex xs12 sm2>
                        <v-autocomplete
                            label="是否统计经费"
                            required
                            :rules="rules.required"
                            v-model="item.countFund"
                            :items=countFundItems
                        />
                      </v-flex>

                        <v-flex xs12 sm2>
                            <v-autocomplete
                                    label="项目性质"
                                    required
                                    :rules="rules.required"
                                    v-model="item.property"
                                    :items="propertyItems"
                            />
                        </v-flex>

                        <v-flex xs12 sm6>
                            <!--
                            <x-user-select-form
                              label="项目负责人"
                              :rules="rules.required"
                              v-model="item.leader"
                              hint="输入关键词，检索添加本单位项目负责人；或直接录入外单位项目负责人。"
                              persistent-hint
                            />
                            -->
                            <x-user-select
                                    label="项目负责人"
                                    :rules="rules.required"
                                    v-model="item.leader"
                                    hint="输入关键词，检索添加本单位项目负责人；或直接录入外单位项目负责人。"
                                    persistent-hint
                            />
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="负责人电话"
                                    v-model="item.leaderPhone"/>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-text-field
                                    label="负责人邮箱"
                                    v-model="item.leaderEmail"
                                    :rules="rules.email"
                            />
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-autocomplete
                                    label="承担部门"
                                    clearable
                                    required
                                    :rules="rules.required"
                                    v-model="item.deptId"
                                    item-text="name"
                                    item-value="dbid"
                                    :items="deptItems"
                                    :loading="deptLoading"
                                    :menu-props="{maxHeight:600}"
                                    @change="(nv) => {
                  item.objectiveTypeId = objecTypeItems.find( v => v.deptId === nv).dbid
                  }"
                            />
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-menu
                                    ref="startDatePickerRef"
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="startDateMenu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        label="开始日期"
                                        v-model="item.startDate"
                                        :rules="rules.startDate"
                                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                                        persistent-hint
                                />

                                <v-date-picker
                                        v-model="startDate"
                                        locale="zh-cn"
                                        @change="nv => item.startDate= nv"
                                />
                            </v-menu>
                        </v-flex>

                        <v-flex xs12 sm3>
                            <v-menu
                                    ref="finishDatePickerRef"
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="finishDateMenu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                            >
                                <v-text-field
                                        slot="activator"
                                        label="结束日期"
                                        required
                                        v-model="item.finishDate"
                                        :rules="rules.finishDate"
                                        hint="格式YYYY-MM-DD, 如：2018-10-01"
                                        persistent-hint
                                />

                                <v-date-picker
                                        v-model="finishDate"
                                        locale="zh-cn"
                                        @change="nv => item.finishDate= nv"
                                />
                            </v-menu>
                        </v-flex>

                        <v-flex xs6>
                            <v-autocomplete
                                    label="学科分类"
                                    clearable
                                    required
                                    :rules="rules.required"
                                    v-model="item.subjectId"
                                    item-text="name"
                                    item-value="dbid"
                                    :items="subjectItems"
                                    :loading="subjectLoading"
                            />
                        </v-flex>

                        <v-flex xs6>
                            <v-autocomplete
                                    label="研究活动类别"
                                    clearable
                                    required
                                    :rules="rules.required"
                                    v-model="item.researchTypeId"
                                    item-text="name"
                                    item-value="dbid"
                                    :items="researchTypeItems"
                                    :loading="researchTypeLoading"
                            />
                        </v-flex>

                        <v-flex xs6>
                            <v-autocomplete
                                    label="组织形式"
                                    clearable
                                    required
                                    :rules="rules.required"
                                    v-model="item.organizeForm"
                                    :items="organizeFormItems"
                                    @change="(v)=> { if(v !== '合作单位') item.coopeFormId = null }"
                            />
                        </v-flex>

                        <v-flex xs6>
                            <v-autocomplete
                                    label="合作形式"
                                    v-model="item.coopeFormId"
                                    :disabled="item.organizeForm !== '合作单位'"
                                    :items="coopeFormItems"
                                    item-text="name"
                                    item-value="dbid"
                                    :loading="coopeFormLoading"
                            />
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-autocomplete
                                    item-text="name"
                                    item-value="dbid"
                                    :items="indstTypeItems"
                                    :loading="indstTypeLoading"
                                    v-model="item.industryTypeId"
                                    label="服务的国民经济行业"
                                    hide-details
                                    clearable
                                    :menu-props="{maxHeight:400}"
                            >
                                <template slot="item" slot-scope="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-tile-content v-text="data.item.name"/>
                                    </template>
                                    <template v-else>
                                        <v-list-tile-content>
                                            <v-list-tile-title class="pl-3" v-html="data.item.name"/>
                                        </v-list-tile-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-flex>

                        <v-flex xs12 sm6>
                            <v-autocomplete
                                    label="社会经济目标"
                                    clearable
                                    v-model="item.objectiveTypeId"
                                    item-text="name"
                                    item-value="dbid"
                                    :items="objecTypeItems"
                                    :loading="objecTypeLoading"
                            />
                        </v-flex>

                    </v-layout>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions style="max-width: 990px; margin: 0 auto">
            <v-spacer/>
            <!--<v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>-->
            <v-btn
                    color="primary"
                    :disabled="loading"
                    @click.native="onSave">
              <v-icon dark left>save</v-icon>保存
            </v-btn>
            <v-spacer/>
        </v-card-actions>

        <v-dialog
                scrollable
                v-model="dialogAfterSave"
                max-width="600px"
                :persistent="true"
        >
            <v-card>
                <v-card-title class="subheading">
                    保存完成！
                </v-card-title>

                <v-divider></v-divider>

                <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

                <v-card-text>
                    <div>{{ item.name }}</div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer/>
                    <v-btn flat color="primary" @click.native="newAnother">
                        <v-icon>add</v-icon>
                        新项目立项
                    </v-btn>
                    <v-btn flat color="primary" @click.native="dialogAfterSave = false">
                        <v-icon>edit</v-icon>
                        继续编辑
                    </v-btn>
                    <v-btn flat color="primary" :to="`/proj/manage/${dbid}`">
                        <v-icon>dashboard</v-icon>
                        项目详情
                    </v-btn>
                    <v-btn color="primary" to="/proj/project">
                        <v-icon>list</v-icon>
                        项目列表
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>

</template>
<script>
    import mixin from '@/mixin'

    import XUserSelect from '../global/SystUserSelect'

    const baseUri = '/api/proj/project/basic';

    export default {
        mixins: [mixin.edit_page(baseUri)],
        components: {XUserSelect},
        data() {
            return {
                formValid: false,

                item: {},
                freshItem: {
                    "name": null,
                    "number": null,
                    "leadingUnit": null,
                    "typeId": null,
                    "client": null,
                    "deptId": null,
                    "leader": {},
                    "leaderId": null,
                    "leaderName": null,
                    "leaderPhone": null,
                    "leaderEmail": null,
                    "contractAmounts": null,
                    "startDate": null,
                    "finishDate": null,
                    "subjectId": null,
                    "researchTypeId": null,
                    "organizeForm": '牵头单位',
                    "coopeFormId": null,
                    "industryTypeId": null,
                    "objectiveTypeId": null,
                    "statusId": null,
                    "reviewStatus": null,
                    "entryDate": null,
                    "code": null,
                    "adminDeptId": null,
                    "level": null,
                    "bugetSource": null,
                    "turnover": null,
                    "completedDate": null,
                    "property": null,
                    "countFund": '统计'
                },

                startDateMenu: false,
                startDate: null,

                finishDateMenu: false,
                finishDate: null,

                statusItems: [],
                typeItems: [],
                deptItems: [],
                leaderItems: [],
                subjectItems: [],
                researchTypeItems: [],
                indstTypeItems: [],
                objecTypeItems: [],
                coopeFormItems: [],

                devProjTypeIds: [],

                organizeFormItems: ['牵头单位', '合作单位'],
                propertyItems: [{value: 'zk', text: '自科'}, {value: 'sk', text: '社科'}],
                countFundItems:[{value: 'T', text: '统计'},{value: 'F', text: '不统计'} ],

                statusLoading: false,
                typeLoading: false,
                deptLoading: false,
                leaderLoading: false,
                subjectLoading: false,
                researchTypeLoading: false,
                indstTypeLoading: false,
                objecTypeLoading: false,
                coopeFormLoading: false,

                leaderSearch: '',
                indstClsSearch: '',

                dialogAfterSave: false,

                /**
                 * 验证规则
                 */
                rules: {
                    required: [
                        v => !!v || '必填项。'
                    ],
                    normal: [v => (!v || v.length <= 50) || '长度必须小于50个字符。'],
                    amount: [
                        v => !!v || '必填项。',
                        v => (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v)) || '填写数字，小数点后最多保留2位。'
                    ],
                    email: [
                        v => (!v || /^[\w.-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\.)+[a-z]{2,3}$/ig.test(v)) || '邮箱格式不正确。'
                    ],

                    turnover: [
                        v => (!this.devProjTypeIds.includes(this.item.typeId) || (v && /^\d{1,10}?(.[0-9][0-9]?)?$/ig.test(v))) || '填写数字，小数点后最多保留2位。'
                    ],

                    startDate: [
                        v => !!v || "必填项。",
                        v => window.xutil.regexpDate().test(v) || '日期格式错误'
                    ],
                    finishDate: [
                        v => !!v || "必填项。",
                        v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
                        v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
                    ]
                },

                sectionLoading: false,
                sectionItems: [],
                sectionSearch: ''
            }
        },

        created() {
            const params = {"sort": "rank.asc", "limit": 255};

            const statusUri = '/api/proj/proj-status';
            const typeUri = '/api/proj/project-type/flatten/tree';
            const researchTypeUri = '/api/proj/research-type';
            const objecTypeUri = '/api/proj/objective-type';
            const indstTypeUri = '/api/proj/industry-type/flatten/tree';
            const coopeFormUri = '/api/proj/coope-form';

            const deptUri = '/api/syst/department';
            const subjectUri = '/api/code/subject';

            const contractId = this.$route.query.contractId;
            const ctraUri = `/api/ctra/contract/${contractId}`;

            this.loading = true;

            this.item.countFund = "T"

            const loadings = [
                this.statusLoading, this.typeLoading, this.researchTypeLoading,
                this.objecTypeLoading, this.deptLoading, this.subjectLoading, this.indstTypeLoading, this.coopeFormLoading
            ];
            for (const i in loadings) {
                loadings[i] = true
            }

            this.axios.all([
                this.axios.get(statusUri, {params}),
                this.axios.get(typeUri, {params}),
                this.axios.get(researchTypeUri, {params}),
                this.axios.get(objecTypeUri, {params}),
                this.axios.get(deptUri, {params}),
                this.axios.get(subjectUri, {params}),
                this.axios.get(indstTypeUri),
                this.axios.get(coopeFormUri, {params})
            ]).then(
                this.axios.spread(
                    (rspStat, rspType, rspResearchType, rspObjecCls, rspDept, rspSubject, rspIndst, rspCoope) => {
                        this.statusLoading = false;
                        this.statusItems = rspStat.data.items;

                        this.typeLoading = false;
                        this.typeItems = rspType.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);

                        // 横向合同项目类型
                        this.devProjTypeIds = this.typeItems.filter(v => v.parentId === 'Db2NlYTLADg').map(v => v.dbid);

                        this.researchTypeLoading = false;
                        this.researchTypeItems = rspResearchType.data.items;

                        this.objecTypeLoading = false;
                        this.objecTypeItems = rspObjecCls.data.items;

                        this.deptLoading = false;
                        this.deptItems = rspDept.data.items;

                        this.subjectLoading = false;
                        this.subjectItems = rspSubject.data.items;

                        this.indstTypeLoading = false;
                        this.indstTypeItems = rspIndst.data.reduce(
                            (acc, v, i) => {
                                if (!v.leaf) {
                                    if (i > 0)
                                        acc.push({divider: true}, {header: v.name});
                                    else
                                        acc.push({header: v.name});
                                } else {
                                    acc.push(v);
                                }
                                return acc;
                            }, []);

                        this.coopeFormLoading = false;
                        this.coopeFormItems = rspCoope.data.items;

                        if (contractId) {
                            this.axios.get(ctraUri).then(rsp => {
                                const fields = [
                                    "name",
                                    "adminDeptId",
                                    "deptId",
                                    "leaderId",
                                    // "leaderName",
                                    "statusId",
                                    "typeId",
                                    //"property",
                                    "client",
                                    //"clientTypeId",
                                    //"amount",
                                    //"bidding",
                                    //"applDate",
                                    // "leaderPhone",
                                    // "leaderEmail",
                                    "startDate",
                                    "finishDate",
                                    "turnover",
                                    "industryClassId"];

                                fields.forEach(f => this.item[f] = rsp.data[f]);

                                this.item.contractAmounts = rsp.data.amount;

                                this.item.leader = {
                                    userId: rsp.data.leaderId,
                                    name: rsp.data.leaderName,
                                    deptId: rsp.data.deptId,
                                    phone: rsp.data.leaderPhone,
                                    email: rsp.data.leaderEmail,
                                }
                            });
                        }

                        this.loading = false;
                    }
                )
            );
        },
        watch: {
            "item.leader": function (v) {
                this.item.leaderId = v.userId || v.dbid;
                this.item.leaderName = v.name;

                if (v && v.deptId) this.item.deptId = v.deptId;

                this.item.leaderPhone = v.phone;
                this.item.leaderEmail = v.email;
            }
        },

        methods: {
            newAnother() {
                this.dbid = null;
                this.item = window.xutil.clone(this.freshItem);
                this.defaultItem = window.xutil.clone(this.freshItem);
                this.dialogAfterSave = false;
            },

            afterSave() {
                this.dialogAfterSave = true;
            },

            // 服务的国民经行业
            onIndstClsSearch() {
                const vm = this;
                const param = window.xutil.param("name", this.sectionSearch);
                param["sort"] = "rank.asc";

                vm.indstTypeLoading = true;
                this.axios.get('/api/proj/industry-type', {params: param})
                    .then(
                        rsp => {
                            vm.indstTypeLoading = false;
                            vm.indstTypeItems = rsp.data.items
                        })
            },
        }
    }
</script>
